import React, { useContext } from "react";
import { AccordionContext, Card, useAccordionButton } from "react-bootstrap";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";

type AccordionHeaderToggleProps = {
  children: React.ReactNode;
  eventKey: string;
  callback?: ((key: string) => void) | null;
};

const AccordionHeaderToggle = ({
  children,
  eventKey,
  callback = null,
}: AccordionHeaderToggleProps): JSX.Element => {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey)
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <Card.Header onClick={decoratedOnClick}>
      {children}
      {isCurrentEventKey ? (
        <AiOutlineMinus size={14} />
      ) : (
        <AiOutlinePlus size={14} />
      )}
    </Card.Header>
  );
};

export default AccordionHeaderToggle;
